module.exports = __webpack_public_path__ + "img/icon-3.be17a66a.png";